import { useState } from 'react';
import { toast } from 'sonner';
import { Send } from 'lucide-react';
import { publicApi } from '@/lib/api';
import { trackEvent } from '@/lib/analytics';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

export const ContactForm = ({ source = 'contact_form' }) => {
    const [form, setForm] = useState({ name: '', phone: '', email: '', message: '' });
    const [submitting, setSubmitting] = useState(false);
    const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
    const submit = async (e) => {
        e.preventDefault();
        if (!form.name || !(form.phone || form.email)) {
            toast.error('Por favor incluye tu nombre y al menos un dato de contacto.');
            return;
        }
        setSubmitting(true);
        try {
            await publicApi.submitLead({ ...form, source, preferred_channel: 'whatsapp' });
            trackEvent('form_submit', window.location.pathname, { source });
            toast.success('¡Mensaje enviado! Te contactaremos pronto.');
            setForm({ name: '', phone: '', email: '', message: '' });
        } catch {
            toast.error('No pudimos enviar tu mensaje. Inténtalo nuevamente.');
        } finally {
            setSubmitting(false);
        }
    };
    return (
        <form data-testid="contact-form" onSubmit={submit} className="grid gap-3 sm:grid-cols-2">
            <div className="sm:col-span-2">
                <Label htmlFor="cf-name">Nombre completo *</Label>
                <Input id="cf-name" data-testid="contact-form-name" value={form.name} onChange={(e) => set('name', e.target.value)} className="mt-1" placeholder="Tu nombre" />
            </div>
            <div>
                <Label htmlFor="cf-phone">Teléfono</Label>
                <Input id="cf-phone" data-testid="contact-form-phone" value={form.phone} onChange={(e) => set('phone', e.target.value)} className="mt-1" placeholder="+593 ..." />
            </div>
            <div>
                <Label htmlFor="cf-email">Email</Label>
                <Input id="cf-email" type="email" data-testid="contact-form-email" value={form.email} onChange={(e) => set('email', e.target.value)} className="mt-1" placeholder="correo@ejemplo.com" />
            </div>
            <div className="sm:col-span-2">
                <Label htmlFor="cf-msg">Mensaje</Label>
                <Textarea id="cf-msg" data-testid="contact-form-message" rows={4} value={form.message} onChange={(e) => set('message', e.target.value)} className="mt-1" placeholder="¿En qué podemos ayudarte?" />
            </div>
            <div className="sm:col-span-2">
                <button type="submit" disabled={submitting} data-testid="contact-form-submit-button" className="inline-flex items-center gap-2 rounded-full bg-gradient-fun text-white font-bold font-display px-6 py-3 text-sm shadow-pop hover:scale-[1.02] active:scale-[0.98] disabled:opacity-60 transition">
                    <Send className="size-4" /> {submitting ? 'Enviando…' : 'Enviar mensaje'}
                </button>
            </div>
        </form>
    );
};

export default ContactForm;
